import { render } from "./check-mark.vue?vue&type=template&id=322790d0"
import script from "./check-mark.vue?vue&type=script&lang=js"
export * from "./check-mark.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__